import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../../common/html/element'
import { Icon } from '../../../../../common/html/icon'
import TextEllipsis from '../../../../../common/textEllipsis'
import { Tooltip } from '../../../../../common/tooltip'
import { valToPercent } from '../../../../../helpers/value'
import TooltipExpression from '../../common/tooltipExpression'
import { getStatusQuickAssessment } from '../../helper'
import { GROUP_B } from './constant'
import classes from './index.module.scss'

const casaIndicatorId = 'RT0295'

export const TableB = ({ data, isDynamicReport }) => {
  const renderGroupName = (ratioGroupCode) => {
    const ratio = data.find((item) => item.ratioGroupCode === ratioGroupCode)
    if (!ratio) return <>&nbsp;</>
    return ratio.ratioGroupName
  }

  const renderTooltip = (item) => {
    return (
      <Element>
        <Element>
          <Translate value="financialAnalysis.NORMAL_RANGE" />
        </Element>
        <Element>
          {valToPercent(item.quartile1)} - {valToPercent(item.quartile3)}
        </Element>
      </Element>
    )
  }

  const renderRatio = (ratioCode) => {
    const ratio = data.find(
      (item) => item.ratioCode.trim() === ratioCode.trim(),
    )
    if (!ratio) return <>&nbsp;</>

    return (
      <>
        <div className={`${classes.w25} dFlex`}>
          {ratio.ratioName}
          {!isDynamicReport && ratio.ratioCode === casaIndicatorId && (
            <Tooltip
              tooltipContent={
                <TooltipExpression
                  expressions={[
                    {
                      text: <Translate value="financialAnalysis.CASA_1" />,
                      operator: '=',
                    },
                    {
                      text: <Translate value="financialAnalysis.CASA_2" />,
                      isDivide: true,
                      textUnder: <Translate value="financialAnalysis.CASA_3" />,
                    },
                  ]}
                />
              }
            >
              <Icon
                className="icon-info-circle ml1"
                style={{ color: '#9C9C9C', marginTop: 2 }}
              />
            </Tooltip>
          )}
        </div>
        {ratio.values?.map((item) => (
          <div key={item.year} className={[classes.w17]}>
            <Tooltip
              tooltipContent={renderTooltip(item)}
              contentClass="cursorPointer"
            >
              <div
                className={[classes.w60, classes.maxWidth60, 'textEnd'].join(
                  ' ',
                )}
              >
                <TextEllipsis text={valToPercent(item.value)} isI18n={false} />
              </div>
            </Tooltip>
          </div>
        ))}
        <div className={`${classes.w24} dFlex alignItemsCenter`}>
          {getStatusQuickAssessment(ratio.statusCode, false)}
          <div>{ratio.statusName}</div>
        </div>
      </>
    )
  }

  return (
    <Element className={classes.table} style={{ borderColor: '#D5D5D5' }}>
      <Element
        style={{ borderColor: '#D5D5D5', color: '#191D25' }}
        className={classes.header}
      >
        {[0, 1].map((idx) => (
          <Element
            key={idx}
            className={classes.headerItem}
            style={{ borderColor: '#D5D5D5' }}
          >
            <div className={classes.w25}>
              <Translate value="financialAnalysis.INDICATOR" />
            </div>
            {data?.[0]?.values
              ?.map((item) => item.year)
              .map((year) => (
                <div key={year} className={classes.w17}>
                  <div
                    className={[
                      classes.w60,
                      classes.maxWidth60,
                      'textEnd',
                    ].join(' ')}
                  >
                    {year}
                  </div>
                </div>
              ))}
            <div className={classes.w24}>
              <Translate value="financialAnalysis.STATUS" />
            </div>
          </Element>
        ))}
      </Element>

      <Element className={classes.rowWrapper}>
        {GROUP_B.map((row, index) => (
          <Element key={index} className={classes.row}>
            {row.map((item, idx) => (
              <Element
                key={idx}
                className={classes.rowItem}
                style={{
                  borderColor: '#D5D5D5',
                  backgroundColor: item.ratioGroupCode ? '#F9F9F9' : '',
                  fontWeight: item.ratioGroupCode ? '600' : '400',
                }}
              >
                {!!item.ratioGroupCode && renderGroupName(item.ratioGroupCode)}
                {!!item.ratioCode && renderRatio(item.ratioCode)}
              </Element>
            ))}
          </Element>
        ))}
      </Element>
    </Element>
  )
}
